import { Controller } from 'stimulus';

// CSP-safe replacement for inline `onclick` dismiss handlers: put
// `data-controller="dismiss"` on the element to remove and
// `data-action="dismiss#dismiss"` on the close button inside it.
export default class extends Controller {
  dismiss() {
    this.element.remove();
  }
}
